import { Target, Eye, Quote } from "lucide-react";

const TEAM = [
  { name: "Sandeep Kumar", role: "Founder & CEO" },
  { name: "Priya Sharma", role: "Head of Sales" },
  { name: "Anil Reddy", role: "Legal Head" },
  { name: "Kavya Rao", role: "Customer Relations" },
];

const GALLERY = [
  "https://images.unsplash.com/photo-1505843795480-5cfb3c03f6ff",
  "https://images.unsplash.com/photo-1599409637219-d04e9a2db432",
  "https://images.unsplash.com/photo-1635111057505-3b7dcc2b72fb",
];

export default function About() {
  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">About Us</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Building Trust, One Plot at a Time</h1>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <img src="https://images.pexels.com/photos/9345669/pexels-photo-9345669.jpeg" alt="Family" className="rounded-2xl w-full h-[420px] object-cover shadow-lg" />
        <div>
          <h2 className="font-heading text-3xl font-bold text-gray-900">Our Story</h2>
          <p className="mt-4 text-gray-600 leading-relaxed">For over a decade, Next Gen Properties Telangana has helped 500+ families secure their dream open plots across Hyderabad's fastest-growing corridors. We built our reputation on one simple promise — every plot we sell is legally clear, government approved, and priced for real returns.</p>
          <p className="mt-4 text-gray-600 leading-relaxed">From HMDA-approved gated communities to serene farm plots, we handle everything end-to-end: site visits, documentation, bank loans and registration.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-6 pb-16">
        <div className="rounded-2xl bg-[#f8faf9] p-8"><Target className="text-[#0B5D3B]" size={32}/><h3 className="font-heading text-xl font-bold text-gray-900 mt-4">Our Mission</h3><p className="text-gray-600 mt-2 leading-relaxed">To make premium, legally-clear land ownership accessible and transparent for every family in Telangana.</p></div>
        <div className="rounded-2xl bg-[#f8faf9] p-8"><Eye className="text-[#0B5D3B]" size={32}/><h3 className="font-heading text-xl font-bold text-gray-900 mt-4">Our Vision</h3><p className="text-gray-600 mt-2 leading-relaxed">To be Telangana's most trusted real estate platform — a fully digital, systematic land investment experience.</p></div>
      </div>

      <div className="bg-[#08341f] py-16">
        <div className="max-w-4xl mx-auto px-5 text-center text-white">
          <Quote className="mx-auto text-[#D4AF37]" size={40}/>
          <p className="mt-6 text-xl lg:text-2xl font-heading leading-relaxed">"We don't just sell plots — we build lasting relationships and generational wealth for our customers. Your trust is our foundation."</p>
          <p className="mt-6 font-semibold text-[#D4AF37]">— Sandeep Kumar, Founder</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <h2 className="font-heading text-3xl font-bold text-gray-900 text-center mb-12">Our Team</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {TEAM.map((t) => (
            <div key={t.name} className="text-center rounded-xl border border-gray-100 p-6">
              <span className="grid place-items-center w-16 h-16 rounded-full bg-[#0B5D3B] text-white text-xl font-bold mx-auto">{t.name[0]}</span>
              <h4 className="font-heading font-semibold text-gray-900 mt-4">{t.name}</h4>
              <p className="text-sm text-[#D4AF37] font-medium">{t.role}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 pb-8">
        <h2 className="font-heading text-3xl font-bold text-gray-900 text-center mb-10">Office Gallery</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {GALLERY.map((g,i)=><img key={i} src={g} alt="" className="rounded-xl h-64 w-full object-cover"/>)}
        </div>
      </div>
    </div>
  );
}
